import { LISTING, OFFERS } from '../../utils/routes';
import { STATUS } from '../enum/listing-status';
import { AdCompatibilityInterface } from '../store/contexts/types/ad-compatibility-interface';
import { AdInterface } from '../store/contexts/types/ad';

export interface GetStatusReturn {
  statusIds?: number[];
  color: string;
  label: string;
  actions: {
    label: string;
    className: string;
    incomplete?: boolean;
    payNow?: boolean;
  }[];
  renewableActions?: (
    | {
        label: string;
        className: string;
        redirect: string;
      }
    | {
        label: string;
        className: string;
        republish: boolean;
      }
  )[];
  disclaimer?: string;
}

export const incompleteStatus = {
  color: 'red',
  label: 'Incompleto',
  actions: [
    {
      label: 'Continuar anúncio',
      className: 'btn_qa_completar',
      incomplete: true
    }
  ]
};

export const waitingPaymentStatus = {
  statusIds: [0],
  color: 'yellow',
  label: 'Aguardando Pagamento',
  actions: [
    {
      label: 'Pagar Agora',
      className: 'btn_qa_pagar',
      payNow: true
    }
  ]
};

export const listingStatus = [
  {
    statusIds: [1],
    color: 'green',
    label: 'Publicado',
    isPublished: true,
    actions: [
      {
        label: 'Ver Propostas',
        className: 'btn_qa_propostas',
        redirect: `${OFFERS}/#id`
      },
      {
        label: 'Gerenciar Anúncio',
        className: 'btn_qa_editar',
        redirect: `${LISTING}/#id`
      }
    ],
    renewableActions: [
      {
        label: 'Ver Propostas',
        className: 'btn_qa_propostas',
        redirect: `${OFFERS}/#id`
      },
      {
        label: 'Republicar Anúncio',
        className: 'btn_qa_republicar',
        republish: true
      }
    ]
  },
  {
    ...waitingPaymentStatus
  },
  {
    statusIds: [2, 3, 4, 5, 6],
    color: 'gray',
    label: 'Inativo',
    actions: [
      {
        label: 'Ver Resumo',
        className: 'btn_qa_resumo',
        redirect: `${LISTING}/#id`
      }
    ]
  },
  {
    statusIds: [9],
    color: 'gray',
    label: 'Inativo',
    actions: [
      {
        label: 'Republicar Anúncio',
        className: 'btn_qa_republicar',
        republish: true
      }
    ]
  },
  {
    statusIds: [7, 8, 10],
    color: 'blue',
    label: 'Em Análise',
    disclaimer:
      'Os dados do seu anúncio estão em análise e o prazo para validação é de até 01 (um) dia útil. Fique tranquilo (a), pois você não perderá nenhum dia do plano contratado.',
    actions: [
      {
        label: 'Ver Resumo',
        className: 'btn_qa_resumo',
        redirect: `${LISTING}/#id`
      }
    ]
  }
];

export const getStatus = (listing: AdInterface): GetStatusReturn | null | undefined => {
  if (!listing) {
    return null;
  }

  const {
    podeRenovar: canRenew,
    status,
    incompleto: incomplete,
    pagarAgora: payNow,
    renovavel: renewable
  } = listing;

  if (incomplete) {
    return incompleteStatus;
  }

  if (payNow) {
    return waitingPaymentStatus;
  }

  const currentStatus = (() => {
    const foundStatus = listingStatus.find(
      elem => elem.statusIds.filter(id => id === status?.id).length
    );

    if (foundStatus?.renewableActions) {
      if (renewable && canRenew) {
        return {
          ...foundStatus,
          actions: foundStatus.renewableActions,
          renewableActions: undefined
        };
      }
    }

    return foundStatus;
  })();

  return currentStatus;
};

export const getStatusCompatibility = (
  listing: AdCompatibilityInterface
): GetStatusReturn | null | undefined => {
  if (!listing) {
    return null;
  }

  const {
    podeRenovar: canRenew,
    statusId,
    incompleto: incomplete,
    pagarAgora: payNow,
    renovavel: renewable
  } = listing;

  if (incomplete) {
    return incompleteStatus;
  }

  if (payNow) {
    return waitingPaymentStatus;
  }

  const currentStatus = (() => {
    const foundStatus = listingStatus.find(
      elem => elem.statusIds.filter(id => id === statusId).length
    );

    if (foundStatus?.renewableActions) {
      if (renewable && canRenew) {
        return {
          ...foundStatus,
          actions: foundStatus.renewableActions,
          renewableActions: undefined
        };
      }
    }

    return foundStatus;
  })();

  return currentStatus;
};

export const filterOptionsInitialState = [
  { name: STATUS.all, text: 'todos os anúncios', value: 0 },
  { name: STATUS.active, text: 'publicados', value: 0, statusIds: [1] },
  { name: STATUS.incomplete, text: 'incompletos', value: 0 },
  { name: STATUS.analyzing, text: 'em análise', value: 0, statusIds: [7, 8, 10] },
  { name: STATUS.waiting, text: 'aguardando pagamento', value: 0, statusIds: [0] },
  { name: STATUS.expired, text: 'expirados', value: 0, statusIds: [9] }
  // { name: DEACTIVATED_STATUS, text: 'desativados', value: 0, statusIds: [2, 3, 4, 5, 6] }
];

export function getIndexOfFoundStatus(filterName: string | undefined): number {
  if (!filterName) return -1;
  return filterOptionsInitialState.findIndex(
    filterOptionsItem => filterOptionsItem.name === filterName
  );
}
